module.exports = __webpack_public_path__ + "img/services-activity-photo-3.5374e131.png";